import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map, of } from 'rxjs';
import { KioskService } from '../services/KioskService';
import { IKioskProductsAndPackages } from '../interfaces/IKioskProductsAndPackages';
import { TerminalsStore } from '../../../terminals/core/stores/TerminalsStore';

export const kioskProductsAndPackagesResolver: ResolveFn<IKioskProductsAndPackages> = () => {
  const selectedTerminal = inject(TerminalsStore).selectedTerminal();

  if (!selectedTerminal.currentSession.kioskId) {
    return of(null);
  }

  return inject(KioskService).getKioskProductsAndPackages().pipe(
    map(res => res.data)
  );
};
